var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiLgQuiz = function SvgAiLgQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 61 30"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 22,
    y: 1,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 21.5,
    r: 4.5,
    fill: "#CBFF88",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M17 20h21v3h-5v5H17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M22 5.391c0-.216.175-.391.391-.391H39.61c.216 0 .391.175.391.391v12.913a.4.4 0 0 1-.115.277l-4.304 4.304a.4.4 0 0 1-.277.115H22.391a.39.39 0 0 1-.391-.391zm.783.392v16.434h12.36l4.074-4.075V5.782z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M26.304 15.957v-2.74h.392c1.147 0 1.818-.195 2.2-.501.36-.288.539-.735.539-1.455 0-.676-.25-1.155-.602-1.468-.36-.32-.851-.489-1.355-.489-.503 0-.994.169-1.354.489-.352.313-.602.792-.602 1.468a.391.391 0 0 1-.783 0c0-.889.337-1.585.865-2.054.52-.462 1.204-.685 1.874-.685s1.354.223 1.874.685c.528.47.865 1.165.865 2.054 0 .845-.213 1.572-.831 2.066-.529.423-1.294.625-2.299.665v1.964a.391.391 0 0 1-.783 0M27.087 19.087a.391.391 0 1 1-.783 0v-.783a.391.391 0 0 1 .783 0zM37.26 8.913a.391.391 0 0 1 0 .783h-3.912a.391.391 0 0 1 0-.783zM37.26 12.044a.391.391 0 0 1 0 .782h-3.912a.391.391 0 0 1 0-.783zM37.26 15.174a.391.391 0 0 1 0 .783H31a.391.391 0 0 1 0-.783z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M35.696 18.696v2.968l2.968-2.968zm-.783-.392c0-.216.175-.391.391-.391h4.305a.391.391 0 0 1 .276.668l-4.304 4.304a.391.391 0 0 1-.668-.276z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m50.5 6 .99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566z"
  })));
};
export { SvgAiLgQuiz as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-lg-quiz-5cb8e22f71c56639d14b538dee3c7c62.svg";